import styled from '@emotion/styled';
import { transactionHistoryTabColors } from 'src/assets/colors';

export const TableHeadRow = styled('tr', { label: 'TableHeadRow' })`
    border-bottom: none;
`;

export const TableTitleCell = styled('th', { label: 'TableTitleCell' })`
    font-size: 12px;
    color: #000;
`;

interface TableDataPropsType {
    amountNegative?: boolean
}

export const TransactionHistoryTabContent = styled('div', { label: 'TransactionHistoryTabContent' })`
    min-height: 645px;
`;

export const TableData = styled('td', { label: 'TableData' })<TableDataPropsType>`
    font-size: 12px;
    color: ${({ amountNegative }): string => amountNegative === true ? transactionHistoryTabColors.txtColorSecondary : transactionHistoryTabColors.txtColor};
`;

export const TableDataRow = styled('tr', { label: 'TableDataRow' })`
    border-bottom: none;
    cursor: pointer;
    &:nth-of-type(odd) {
        background-color: #fbfbfb;
    }
`;

export const SelectOptions = styled('select', { label: 'SelectOptions' })`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 12px 0 0 8px;
    box-sizing: border-box;
    border: none;
    appearance: none;
    background-color: transparent;
    font-size: 12px;
    line-height: 1;
`;

export const SelectOptionsWrapper = styled('div', { label: 'SelectOptionsWrapper' })`
    position: relative;
    height: 32px;
    padding: 3px 0 0 8px;
    box-shadow: inset 0 1px 3px 0 rgba(0,0,0,0.5);
    border: solid 1px #d7d7d7;
    font-size: 10px;
    color: #acacac;
    line-height: 1;
    &::after {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 8px;
        content: '';
        width: 0;
        height: 0;
        margin: auto;
        border-style: solid;
        border-width: 4px 4px 0 4px;
        border-color: #2b2b2b transparent transparent transparent;
        pointer-events: none;
    }
`;
